import { FC } from 'react'
import { translate } from '../index'
import { Form, Input, Modal } from 'antd'
import { SendOutlined } from '@ant-design/icons'
import { SendEmailAttachments } from './SendEmailAttachments'
import { ShowIf } from './ShowIf'

type OrderSendEmailProps = {
  open: boolean
  onCancel: () => void
  onSend: (input: SendEmailInput) => void
  sending: boolean
  attachment?: {
    enabled: boolean
    prefix: string
  }
  data?: SendEmailInput
}

export type SendEmailInput = {
  to: string
  subject: string
  text: string
}

export const SendEmailWithReceiver: FC<OrderSendEmailProps> = ({open, onCancel, onSend, sending, attachment, data}) => {
  const [form] = Form.useForm<SendEmailInput>()
  form.setFieldsValue(data ?? {});
  return (
    <>
      <Modal
        open={open}
        title={translate('send', 'email')}
        width='30%'
        onCancel={onCancel}
        onOk={form.submit}
        okButtonProps={{
          icon: <SendOutlined/>,
          loading: sending,
        }}
        okText={translate('send')}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <Form
          name='sendEmail'
          layout='vertical'
          form={form}
          onFinish={onSend}
        >
          <Form.Item
            label={translate('to')}
            name='to'
          >
            <Input placeholder='Enter email address' disabled={!!data?.to}/>
          </Form.Item>

          <Form.Item
            label={translate('subject')}
            name='subject'
          >
            <Input/>
          </Form.Item>

          <Form.Item
            label={translate('text')}
            name='text'
          >
            <Input.TextArea
              rows={5}
            />
          </Form.Item>

          <ShowIf
            condition={!!attachment?.enabled}
            replacement={<></>}
          >
            <Form.Item
              name='attachments'
            >
              <SendEmailAttachments
                prefix={attachment?.prefix}
              />
            </Form.Item>
          </ShowIf>
        </Form>
      </Modal>
    </>
  )
}